import { motion } from 'framer-motion';
import { useMemo } from 'react';

import useNavIconVariants from '../../lib/hooks/useNavIconVariants';

import { INavIcon } from './types';

export default function Player({ active, ...props }: INavIcon) {
  const variants = useNavIconVariants();

  const variant = useMemo(
    () => (active ? variants.active : variants.default),
    [active, variants]
  );

  return (
    <motion.svg
      initial={variants.default}
      animate={variant}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      width={20}
      height={20}
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        d="M16.6654 13.6537C17.082 13.3973 17.4987 11.2178 17.4987 9.1665C17.4987 7.11522 17.082 4.93573 16.6654 4.67932C16.2487 4.42291 13.332 4.1665 9.9987 4.1665C6.66536 4.1665 3.7487 4.42291 3.33203 4.67932C2.91536 4.93573 2.4987 7.11522 2.4987 9.1665C2.4987 11.2178 2.91536 13.3973 3.33203 13.6537M3.1237 13.7498H16.8737C17.449 13.7498 17.9154 14.2162 17.9154 14.7915C17.9154 15.3668 17.449 15.8332 16.8737 15.8332H3.1237C2.5484 15.8332 2.08203 15.3668 2.08203 14.7915C2.08203 14.2162 2.5484 13.7498 3.1237 13.7498Z"
        stroke="current"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.53044 6.6665C8.53044 6.6665 8.33203 7.36095 8.33203 8.74984C8.33203 10.1387 8.53044 10.8332 8.53044 10.8332C8.53044 10.8332 9.32409 10.6596 10.713 9.96511C12.1019 9.27067 12.4987 8.74984 12.4987 8.74984C12.4987 8.74984 12.1019 8.229 10.713 7.53456C9.32409 6.84012 8.53044 6.6665 8.53044 6.6665Z"
        stroke="current"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  );
}
